import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/budget-category";

export const getAllConceptAttributeType = () => axios.get(API_PATH + "/getAll");

export const pagingRevenueExpenditure = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getRevenueExpenditureById = (conceptAttributeTypeId) => axios.get(API_PATH + "/get-by-id/" + conceptAttributeTypeId);

export const saveRevenueExpenditure = conceptAttributeType => axios.post(API_PATH + "/save-or-update", conceptAttributeType);

export const deleteRevenueExpenditure = conceptAttributeTypeId => axios.delete(API_PATH + '/mark-delete/' + conceptAttributeTypeId)
